import { useState, useEffect } from 'react';
import { profileResolver } from '../services/profileResolver';
import { Profile } from '../types/chat';

/**
 * Hook to resolve and cache user profile
 * Hides pubkey complexity from UI
 */
export function useUserProfile(pubkey: string | null) {
    const [profile, setProfile] = useState<Profile | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
        if (!pubkey) {
            setProfile(null);
            return;
        }

        let cancelled = false;

        async function loadProfile() {
            setLoading(true);
            setError(null);

            try {
                const resolved = await profileResolver.resolveProfile(pubkey as string);

                if (!cancelled) {
                    setProfile(resolved);
                }
            } catch (err) {
                if (!cancelled) {
                    setError(err instanceof Error ? err : new Error('Profile yüklenemedi'));
                }
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        }

        loadProfile();

        return () => {
            cancelled = true;
        };
    }, [pubkey]);

    return { profile, loading, error };
}
